import React from 'react';

const ExecutionIcon = ({ size, color = "rgb(220, 96, 30)" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 24 24"
  >
    <path
      fill={color}
      fillRule="evenodd"
      d="M12 8q-.4 0-.78.076l.098.49.194.982.097.49Q11.797 10 12 10a2 2 0 1 1-.391 3.962l-.098.49-.193.981-.098.49Q11.6 16 12 16a4 4 0 0 0 0-8m-2.223.674c-.436.292-.81.667-1.103 1.103l.416.278.83.556.416.278c.147-.218.335-.406.553-.553l-.278-.415-.556-.831zm-1.7 2.546a4 4 0 0 0 0 1.56l.49-.098.98-.194.491-.097a2 2 0 0 1 0-.782l-.49-.098-.981-.193zm.597 3.003c.292.436.667.81 1.103 1.103l.278-.416.556-.83.278-.416a2 2 0 0 1-.553-.553l-.415.278-.831.556z"
      clipRule="evenodd"
    />
  </svg>
);


export default ExecutionIcon;
